<template>
  <main>
    <div
      class="koc-view koc-events-purchase-view"
      :class="darkTheme ? 'koc-dark-theme' : ''"
      data-observe-resize
    >
      <div
        v-if="state.events"
        class=""
      >
        <div
          v-if="!replaysOnly"
          class="koc-events-purchase-view-tab-nav-container"
        >
          <div class="koc-events-purchase-view-wrapper">
            <div class="koc-row koc-flex koc-tabs koc-dark koc-large">
              <span
                :class="{ active: 'past' === state.active }"
                class="koc-button"
                @click="state.active = 'past'"
              >Past Conferences</span>
              <span
                :class="{ active: 'future' === state.active }"
                class="koc-button"
                @click="state.active = 'future'"
              >Current | Upcoming Conferences</span>
            </div>
          </div>
        </div>

        <div class="koc-events-purchase-view-wrapper">
          <div
            v-if="'past' === state.active"
            class="koc-events-purchase-view-list koc-medium"
          >
            <div
              v-for="event in state.pastEvents"
              :key="event.id"
              class="koc-events-purchase-card-container koc-one-third"
            >
              <event-card-component
                :event="event"
                :user="state.hasUser"
                :user-events="state.userEvents"
                @show-login="showLogin"
              />
            </div>
          </div>
          <div
            v-if="'future' === state.active"
            class="koc-block"
          >
            <div
              v-if="state.futureEvents.length"
              class="koc-events-purchase-view-list koc-medium"
            >
              <div
                v-for="event in state.futureEvents"
                :key="event.id"
                class="koc-events-purchase-card-container koc-one-third"
              >
                <event-card-component
                  :event="event"
                  :user="state.hasUser"
                  :user-events="state.userEvents"
                  @show-login="showLogin"
                />
              </div>
            </div>
            <div
              v-else
              class="koc-events-purchase-no-events-container"
            >
              <h1 class="koc-body-3">
                We Do Not Currently Have Any Events Open for Registration
              </h1>
              <p class="koc-body-1">
                But rest assured we always have something in the works. If you don’t see anything
                just
                yet that just means we are busy planning another amazing event. So, get your camera
                ready, brush up on
                your skills with some of our incredible past conference replays, and then be sure to
                check back here
                often
                to see any upcoming live—online—events!
              </p>
            </div>
          </div>

          <div
            v-if="state.showNotification"
            class="koc-notification koc-dark koc-full"
          >
            <h3>{{ state.notification }}</h3>
            <div
              class="koc-close"
              @click="clearNotification"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="state.showLogin"
      class="koc-notification koc-fixed koc-dark koc-full"
    >
      <div class="koc-login-overlay-form-container">
        <div class="koc-kol-logo-container">
          <img src="@/assets/images/kol-logo-white.png">
        </div>
        <h3 class="koc-auth-login-notification-text">
          {{ state.notification }}
        </h3>
        <auth-login-component @login="login" />
      </div>
      <div
        class="koc-close"
        @click="closeLogin"
      />
    </div>
  </main>
</template>

<script src="./kol-events-purchase.js"></script>
<style lang="scss" scoped src="./kol-events-purchase.scss"></style>
